import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Video from '../../../advideo/AdCore/Media/Video';
import Img from '../../../advideo/AdCore/Media/Img';
import Iframe from '../../../advideo/AdCore/Media/Iframe';

class AdMedia extends PureComponent {
    static propTypes = {
        content: PropTypes.object.isRequired,
        methods: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        this.mediaRef = React.createRef();
    }

    componentDidMount() {
        const { methods, content } = this.props;
        const { handleCanplay, handleTimeupdate, handleEnded } = methods;
        const { index, data } = content;
        const { vol } = data;

        this.mediaRef.current.show();
        this.mediaRef.current.setVolume(vol);

        this.mediaRef.current.on('canplay', () => {
            handleCanplay(index);
        });

        this.mediaRef.current.on('timeupdate', () => {
            handleTimeupdate({ index, currentTime: this.mediaRef.current.getDom().currentTime });
        });

        this.mediaRef.current.on('ended', () => {
            handleEnded({ index, currentTime: this.mediaRef.current.getDom().currentTime });
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { methods, content } = this.props;
        const { data, playIndex, index, canPlaySounds, clickPlaySounds } = content;
        const { vol } = data;
        const { handleChangeCanPlaySounds } = methods;

        if (prevProps.content.playIndex !== playIndex) {
            if (playIndex === index) {
                const playPromise = this.mediaRef.current.play();

                if (playPromise) {
                    playPromise
                        .then(() => {
                            if (
                                (vol === 0 || this.mediaRef.current.getVolume() > 0) &&
                                !this.mediaRef.current.getMuted()
                            ) {
                                handleChangeCanPlaySounds(true);
                            }
                        })
                        .catch((e) => {
                            console.error(e);
                            handleChangeCanPlaySounds(false);
                            this.mediaRef.current.setVolume(0);
                            this.mediaRef.current.setMuted(true);
                            this.mediaRef.current.play();
                        });
                } else {
                    this.mediaRef.current.setVolume(vol);
                }
            }
        }

        if (
            prevProps.content.canPlaySounds !== canPlaySounds ||
            prevProps.content.clickPlaySounds !== clickPlaySounds
        ) {
            if (canPlaySounds && clickPlaySounds) {
                this.mediaRef.current.setVolume(vol);
                this.mediaRef.current.setMuted(false);
            } else {
                this.mediaRef.current.setVolume(0);
                this.mediaRef.current.setMuted(true);
            }
        }
    }

    render() {
        const { content } = this.props;
        const { data, playerWidth, playerHeight, index } = content;
        const {
            adUrl: url,
            materialType: type,
            materialWidth: width,
            materialHeight: height,
            oneadTime: duration,
        } = data;
        const mediaData = { index, url, type, width, height, duration, playerWidth, playerHeight };

        switch (type) {
            case 'video':
                return <Video content={mediaData} ref={this.mediaRef} />;
            case 'img':
                return <Img content={mediaData} ref={this.mediaRef} />;
            case 'iframe':
                return <Iframe content={mediaData} ref={this.mediaRef} />;
            default:
                return null;
        }
    }
}

export default AdMedia;
